export const showpadImageProxyUrl = (url: string) => {
    return `/api-client/proxy-showpad-image?imageUrl=${encodeURIComponent(url)}`;
};
